import React, { useState } from 'react';
import {
    Avatar, Button, TextField, FormControlLabel,
    Checkbox, Link, Stack, Box, Typography, Container
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { apiPath, parseJsonResponse } from './api';

function Copyright() {
    return (
        <Typography id="copyright-text" variant="body2" color="text.secondary" align="center">
            {'Copyright © '}
            <Link id="copyright-link" color="inherit" href="https://mui.com/">
                qualityassurance.work
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

function SignIn() {
    const [state, setState] = useState({
        email: '',
        password: '',
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { id, value = '' } = e.target;
        setState((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(apiPath('/login'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: state.email,
                    password: state.password,
                }),
            });

            const data = await parseJsonResponse(response);

            if (response.ok && data.token) {
                localStorage.setItem('jwtToken', data.token);
                navigate('/dashboard');
            } else {
                alert(data.message || 'Login failed. Please check your credentials.');
            }
        } catch (error) {
            console.error('Network error or unexpected issue:', error);
            alert('An error occurred. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>
                <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={state.email}
                        onChange={handleChange}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={state.password}
                        onChange={handleChange}
                    />
                    <FormControlLabel
                        control={<Checkbox id="remember-me-checkbox" value="remember" color="primary" />}
                        label="Remember me"
                    />
                    <Button
                        id="signin-submit-button"
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={loading}
                        sx={{ mt: 3, mb: 2 }}
                    >
                        {loading ? 'Signing in…' : 'Sign In'}
                    </Button>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ width: '100%' }}
                    >
                        <Link
                            id="forgot-password-link"
                            component="button"
                            type="button"
                            variant="body2"
                            onClick={() => alert('Password reset is not available yet.')}
                        >
                            Forgot password?
                        </Link>
                        <Link
                            id="signup-link"
                            component={RouterLink}
                            to="/signup"
                            variant="body2"
                        >
                            {"Don't have an account? Sign Up"}
                        </Link>
                    </Stack>
                </Box>
            </Box>
            <Box sx={{ mt: 8 }}>
                <Copyright />
            </Box>
        </Container>
    );
}

export default SignIn;
